module.exports = __webpack_public_path__ + "static/54de9762-167f-4bfc-947d-e87c8d0531ed-7470d7938619c1485d696f58f6c38ea9.webp";